import Axios from 'axios';

import { appendAuth } from './axiosService';
// import { validateFileLink } from '@utils';
import { validateFileLink } from '../utils/index';
import { filterXSS } from 'xss';

const baseURL = `${process.env.REACT_APP_service_url}/api/v1`;

const downloader = Axios.create({
  baseURL,
  withCredentials: true,
});

downloader.interceptors.request.use(
  (config) => {
    appendAuth(config);
    return { ...config, responseType: 'blob' };
  },
  (error) => Promise.reject(error),
);

const getDownloadFile = (response) => {
  let fileName = 'Untitled';
  if (
    response.headers['content-disposition'] ||
    response.headers['content-disposition'].includes('filename')
  ) {
    fileName = response.headers['content-disposition']
      ?.split('filename=')[1]
      ?.replace(/\"/g, '');
  }

  const file = window.URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = file;
  a.download = fileName;
  a.click();
};

downloader.interceptors.response.use(getDownloadFile, (error) =>
  Promise.reject(error),
);

export const getFile = (link) => {
  const xssLink = filterXSS(link);
  if (validateFileLink(xssLink)) {
    return downloader.get(xssLink);
  }
  throw new Error('Invalid file link.');
};
